import { render, staticRenderFns } from "./AccessControl.vue?vue&type=template&id=211d95c5&"
import script from "./AccessControl.vue?vue&type=script&lang=js&"
export * from "./AccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports